import { SERVICE_NAME } from '../Constant/Enums';

import Photographer from './../Assets/Thumbnails/Photographer.webp';
import SoundSystem from './../Assets/Thumbnails/SoundSystem.webp';
import Cake from './../Assets/Thumbnails/Cake.webp';
import FashionDesigner from './../Assets/Thumbnails/FashionDesigner.webp';
import Catering from './../Assets/Thumbnails/Catering.webp';
import Decoration from './../Assets/Thumbnails/Decoration.webp';
import Makeup from './../Assets/Thumbnails/Makeup.webp';
import HennaArtist from './../Assets/Thumbnails/HennaArtist.webp';

/** @param {keyof SERVICE_NAME} category */
function getThumbnailImage(category) {
  switch (category) {
    case SERVICE_NAME.PHOTOGRAPHER_AND_VIDEOGRAPHER:
      return Photographer;
    case SERVICE_NAME.SOUND_SYSTEM:
      return SoundSystem;
    case SERVICE_NAME.CAKE_MAKERS:
      return Cake;
    case SERVICE_NAME.FASHION_DESIGNER:
      return FashionDesigner;
    case SERVICE_NAME.CATERING_EVENT:
      return Catering;
    case SERVICE_NAME.DECORATIONS:
      return Decoration;
    case SERVICE_NAME.MAKEUP_ARTIST:
      return Makeup;
    case SERVICE_NAME.HENNA_ARTIST:
      return HennaArtist;
    //no default
  }
}

export default getThumbnailImage;
